import { EnumResolver } from '../../../../commons/enums/enum-resolver.js';

// @lib-export
var ApplicationTypesVo;
(function (ApplicationTypesVo) {
    ApplicationTypesVo["ACTIVITIES_DISCUSSIONS"] = "ACTIVITIES_DISCUSSIONS";
    ApplicationTypesVo["ADMINISTRATION"] = "ADMINISTRATION";
    ApplicationTypesVo["ALL_ITEMS"] = "ALL_ITEMS";
    ApplicationTypesVo["ANALYTICS_CHART"] = "ANALYTICS_CHART";
    ApplicationTypesVo["ANALYTICS_REPORT"] = "ANALYTICS_REPORT";
    ApplicationTypesVo["BUDGETING"] = "BUDGETING";
    ApplicationTypesVo["BUDGETING_INVOICING"] = "BUDGETING_INVOICING";
    ApplicationTypesVo["BUDGETING_QUOTES"] = "BUDGETING_QUOTES";
    ApplicationTypesVo["CONTAINERS"] = "CONTAINERS";
    ApplicationTypesVo["CUSTOMER_PORTAL"] = "CUSTOMER_PORTAL";
    ApplicationTypesVo["DASHBOARD"] = "DASHBOARD";
    ApplicationTypesVo["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    ApplicationTypesVo["MESSENGER"] = "MESSENGER";
    ApplicationTypesVo["PROFILE"] = "PROFILE";
    ApplicationTypesVo["REPORTS"] = "REPORTS";
    ApplicationTypesVo["REQUIREMENTS"] = "PRODUCT_MANAGEMENT";
    ApplicationTypesVo["TASKS"] = "PROJECT_MANAGEMENT";
    ApplicationTypesVo["TICKETS"] = "FEEDBACK_MANAGEMENT";
    ApplicationTypesVo["TIME_SHEETS"] = "TIME_SHEETS";
    ApplicationTypesVo["USERS"] = "USERS";
    ApplicationTypesVo["WEB_FORMS"] = "WEB_FORMS";
    ApplicationTypesVo["WEB_PAGES"] = "WEB_PAGES";
    ApplicationTypesVo["WORK_ITEM_CUSTOMS_FIVE"] = "CUSTOM_ITEM_CATEGORY_5";
    ApplicationTypesVo["WORK_ITEM_CUSTOMS_FOUR"] = "CUSTOM_ITEM_CATEGORY_4";
    ApplicationTypesVo["WORKFLOW_AUTOMATION"] = "WORKFLOW_AUTOMATION";
})(ApplicationTypesVo || (ApplicationTypesVo = {}));
const APPLICATION_TYPES_VO_RESOLVER = new EnumResolver(`ApplicationTypesVo`, Object.entries(ApplicationTypesVo));

export { APPLICATION_TYPES_VO_RESOLVER, ApplicationTypesVo };
//# sourceMappingURL=application-types-vo.js.map
